import React from "react";

import { Link } from "@tanstack/react-router";

import { Button } from "../components/ui/button";
import { NAVIGATION_PATHS } from "../constants/navigation";

/**
 * NotFound page component
 * Displays when a user accesses an undefined route
 */
const NotFound: React.FC = () => {
  return (
    <div className="flex h-full min-h-[70vh] flex-col items-center justify-center p-8">
      <div className="w-full max-w-lg rounded-xl bg-background-white p-8 text-center shadow-md">
        <h1 className="mb-4 text-2xl font-bold text-gray-800">Page Not Found</h1>

        <p className="mb-6 text-pretty text-foreground-muted">
          The page you are looking for doesn&apos;t exist or has been moved.
        </p>
        <Link to={NAVIGATION_PATHS.DASHBOARD}>
          <Button>Return to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
